import { createTheme, ThemeProvider } from "@mui/material/styles";
import React from "react";
import { I18nextProvider } from "react-i18next";
import SwaggerClient from "swagger-client";
import { createAppModel, getConfig, start } from "zebdsh.appframe";
import { authentication } from "zebdsh.login.authentication";
import i18nextInstance from "./i18n";
import { StoreContext } from "./StoreContext";
import { RootStoreImpl } from "./stores/RootStoreImpl";
import { AppWidget } from "./view/AppWidget";
import Locationbar from "./view/Locationbar";
const targetDiv = document.getElementById("zebDshAppFrame");
let isLocal = (targetDiv === null || targetDiv === void 0 ? void 0 : targetDiv.getAttribute("isLocal")) == "true";
const config = getConfig();
const authProps = Object.assign({}, config.auth);
authProps["isAuthenticationRequired"] = !isLocal && config.isAuthOptional != true;
const appModel = createAppModel({ title: { default: "Processcontrol: Dataintegration" } });
authentication.initialize(authProps);
let client = new SwaggerClient({
    url: isLocal
        ? "http://localhost:8005/api/process-controlling-cockpit/v1.0/openapi.json"
        : location.origin + "/api/process-controlling-cockpit/v1.0/openapi.json",
    requestInterceptor: (request) => {
        const token = authentication.getAccessToken();
        if (token) {
            request.headers["Authorization-Token"] = "Bearer " + token;
        }
        return request;
    },
});
let storeContext = {
    rootStore: new RootStoreImpl(client),
    client: client,
};
authentication.login(() => {
    const app = (React.createElement(ThemeProvider, { theme: createTheme({}) },
        React.createElement(I18nextProvider, { i18n: i18nextInstance },
            React.createElement(StoreContext.Provider, { value: Object.assign({}, storeContext) },
                React.createElement(Locationbar, null,
                    React.createElement(AppWidget, { appModel: appModel, isLocal: isLocal }))))));
    start(app);
});
